module.exports = __webpack_public_path__ + "static/img/post-02.e6a70a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/post-02.png
// module id = 409
// module chunks = 1